import { render } from "./faqPcIndex.vue?vue&type=template&id=208062d5"
import script from "./faqPcIndex.vue?vue&type=script&lang=js"
export * from "./faqPcIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__